import React from 'react';
import { SPEED_LABELS } from '../stepCompiler';

// Small floating menu shown when an arrow is tapped in step mode
export default function StepPopover({ target, x, y, step, tactic, onMoveEdit, onActionEdit, onClose }) {
    if (!target || !step || !tactic) return null;
    const players = tactic.players || [];

    let title, options, removeLabel, onRemove;
    if (target.kind === 'move') {
        const move = (step.moves || []).find(m => m.playerIndex === target.playerIndex);
        if (!move) return null;
        title = `Movimiento · ${players[target.playerIndex]?.label || ''}`;
        options = Object.keys(SPEED_LABELS).map(key => ({
            key, label: SPEED_LABELS[key], active: (move.speed || 'normal') === key,
            onClick: () => onMoveEdit(target.playerIndex, { speed: key }),
        }));
        removeLabel = 'Quitar movimiento';
        onRemove = () => onMoveEdit(target.playerIndex, null);
    } else {
        const action = step.action;
        if (!action) return null;
        const from = players[action.from]?.label || '';
        title = action.type === 'pass'
            ? `Pase · ${from} → ${players[action.to]?.label || ''}`
            : `Tiro · ${from}`;
        options = [
            { key: 'start', label: 'Al inicio',  active: action.timing !== 'end', onClick: () => onActionEdit({ timing: 'start' }) },
            { key: 'end',   label: 'Al llegar',  active: action.timing === 'end', onClick: () => onActionEdit({ timing: 'end' }) },
        ];
        removeLabel = action.type === 'pass' ? 'Quitar pase' : 'Quitar tiro';
        onRemove = () => onActionEdit(null);
    }

    const choose = fn => () => { fn(); onClose(); };

    return (
        <div
            className="step-popover"
            style={{ left: x, top: y }}
            onPointerDown={e => e.stopPropagation()}
        >
            <div className="step-popover-title">
                <span>{title}</span>
                <button className="step-popover-close" onClick={onClose} title="Cerrar">×</button>
            </div>
            {target.kind === 'action' && <div className="step-popover-label">¿Cuándo sale el disco?</div>}
            <div className="step-popover-options">
                {options.map(o => (
                    <button key={o.key} className={o.active ? 'active' : ''} onClick={choose(o.onClick)}>
                        {o.label}
                    </button>
                ))}
            </div>
            <button className="step-popover-remove" onClick={choose(onRemove)}>{removeLabel}</button>
        </div>
    );
}
